export default __webpack_public_path__ + "static/media/loader.c533b12f.gif";